/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import settings from './settings';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'ConflictDetection',

    components: { Toggler },

    mixins: [settings],

    data() {
        return {
            innerValue: {
                conflict_detection: {},
            }
        };
    },

    methods: {
        init() {
            this.innerValue.conflict_detection = this.event.conflict_detection || {
                enabled: false,
                meetings: false,
                registered_sessions: false,
                targeted_sessions: false,
            };
        },

        preSubmitHook() {
            if (!this.innerValue.conflict_detection.enabled) {
                this.innerValue.conflict_detection = null;
            }
        },

        t(path) {
            return this.$t(`general_settings.conflict_detection.${path}`);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"conflict-detection",attrs:{"tag":"form","autocomplete":"off"}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.menu.conflict_detection')))]),_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.t('enabled_tooltip')))])]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"enabled","on-label":_vm.t('enabled_label'),"off-label":_vm.t('enabled_label'),"inline-hint":_vm.t('enabled_description')},model:{value:(_vm.innerValue.conflict_detection.enabled),callback:function ($$v) {_vm.$set(_vm.innerValue.conflict_detection, "enabled", $$v)},expression:"innerValue.conflict_detection.enabled"}})],1),(_vm.innerValue.conflict_detection.enabled)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"meetings","on-label":_vm.t('meetings_label'),"off-label":_vm.t('meetings_label'),"inline-hint":_vm.t('meetings_description')},model:{value:(_vm.innerValue.conflict_detection.meetings),callback:function ($$v) {_vm.$set(_vm.innerValue.conflict_detection, "meetings", $$v)},expression:"innerValue.conflict_detection.meetings"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"targeted_sessions","on-label":_vm.t('targeted_sessions_label'),"off-label":_vm.t('targeted_sessions_label'),"inline-hint":_vm.t('targeted_sessions_description')},model:{value:(_vm.innerValue.conflict_detection.targeted_sessions),callback:function ($$v) {_vm.$set(_vm.innerValue.conflict_detection, "targeted_sessions", $$v)},expression:"innerValue.conflict_detection.targeted_sessions"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"registered_sessions","on-label":_vm.t('registered_sessions_label'),"off-label":_vm.t('registered_sessions_label'),"inline-hint":_vm.t('registered_sessions_description')},model:{value:(_vm.innerValue.conflict_detection.registered_sessions),callback:function ($$v) {_vm.$set(_vm.innerValue.conflict_detection, "registered_sessions", $$v)},expression:"innerValue.conflict_detection.registered_sessions"}})],1)],1):_vm._e()],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ConflictDetection.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__